import { LayoutContainer } from 'src/common/components/Layout/LayoutContainer';
import Footer from '@tenant/components/Footer';
import Logo from '@tenant/components/Logo';
import TenantSpinner from '@tenant/components/Spinner';

import styled, { css } from 'styled-components';
import { media } from 'src/common/styles/breakpoints';
import {IntlFormattedMessage} from 'src/common/components/IntlFormattedMessage';

const Layout = styled(LayoutContainer)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const LoaderWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

//todo: unify typography
const LoaderText = styled.h3`
  margin-top: 2rem;
  text-align: center;

  ${media.w.max.px768(css`
    font-size: 1rem;
  `)}
`;

const StyledLogo = styled(Logo)`
  justify-content: flex-end;

  ${media.w.max.px992(css`
    img {
      max-height: 2.1875rem;
    }
  `)}
`;

// todo: should be unified with AspspSdkVerificationLoader
export const VerificationPageLoader = () => {
  return (
    <Layout>
      <StyledLogo fetchPartnerLogo={false} />
      <LoaderWrapper>
        <TenantSpinner />
        <LoaderText>
            <IntlFormattedMessage id="verificationPage.message"/>
        </LoaderText>
      </LoaderWrapper>
      <Footer />
    </Layout>
  );
};
